<template>
  <v-progress-linear absolute :active="progress" indeterminate></v-progress-linear>
</template>
<script>
export default {
  computed: {
    progress() {
      return this.$store.state.feedbackProgress;
    },
  },
};
</script>